/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.content.themes.modules.rpc.ThemePresetRpc
 */

/**
 * Record for com.hubspot.chirp.core.CausalChainLink
 */

/**
 * Record for com.hubspot.chirp.core.ChirpMethodCoordinates
 */

export const BooleanFieldValueTypename = 'com.hubspot.chirp.ext.models.BooleanFieldValue';
export const DoubleFieldValueTypename = 'com.hubspot.chirp.ext.models.DoubleFieldValue';
export const FloatFieldValueTypename = 'com.hubspot.chirp.ext.models.FloatFieldValue';
export const IntFieldValueTypename = 'com.hubspot.chirp.ext.models.IntFieldValue';
export const ListFieldValueTypename = 'com.hubspot.chirp.ext.models.ListFieldValue';
export const LongFieldValueTypename = 'com.hubspot.chirp.ext.models.LongFieldValue';
export const MapFieldValueTypename = 'com.hubspot.chirp.ext.models.MapFieldValue';
export const NullFieldValueTypename = 'com.hubspot.chirp.ext.models.NullFieldValue';
export const StringFieldValueTypename = 'com.hubspot.chirp.ext.models.StringFieldValue';
export const getByIdRpc = {
  serviceName: 'com.hubspot.content.themes.modules.rpc.ThemePresetRpc',
  rpcName: 'getById',
  auth: 'app',
  fingerprint: '4S30eM5qqOKnuTuusXODv_d3p3PJOCBD',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const listByPathRpc = {
  serviceName: 'com.hubspot.content.themes.modules.rpc.ThemePresetRpc',
  rpcName: 'listByPath',
  auth: 'app',
  fingerprint: '0kfkxb4NDef1kyxIh8fwVZwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const listGlobalStylesPresetsRpc = {
  serviceName: 'com.hubspot.content.themes.modules.rpc.ThemePresetRpc',
  rpcName: 'listGlobalStylesPresets',
  auth: 'app',
  fingerprint: 'UzyQRVHqhh31kyxIh8fwVZwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const listRpc = {
  serviceName: 'com.hubspot.content.themes.modules.rpc.ThemePresetRpc',
  rpcName: 'list',
  auth: 'app',
  fingerprint: 'UzyQRVHqhh31kyxIh8fwVZwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const createRpc = {
  serviceName: 'com.hubspot.content.themes.modules.rpc.ThemePresetRpc',
  rpcName: 'create',
  auth: 'app',
  fingerprint: 'hMi8jrz-QPunuTuusXODv5wP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const updateRpc = {
  serviceName: 'com.hubspot.content.themes.modules.rpc.ThemePresetRpc',
  rpcName: 'update',
  auth: 'app',
  fingerprint: 'HjtAnI-Mo8GnuTuusXODv5wP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const deleteRpc = {
  serviceName: 'com.hubspot.content.themes.modules.rpc.ThemePresetRpc',
  rpcName: 'delete',
  auth: 'app',
  fingerprint: 'GrYmmWVVmcTBIV0pXcghjpwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const updateScreenshotS3KeyRpc = {
  serviceName: 'com.hubspot.content.themes.modules.rpc.ThemePresetRpc',
  rpcName: 'updateScreenshotS3Key',
  auth: 'app',
  fingerprint: 'hkvhVn6Lc6bBIV0pXcghjpwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const listDefaultPresetsRpc = {
  serviceName: 'com.hubspot.content.themes.modules.rpc.ThemePresetRpc',
  rpcName: 'listDefaultPresets',
  auth: 'app',
  fingerprint: 'AAAAAAAAAAD1kyxIh8fwVZwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};